import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import FormulaTextLabel from 'automation-ui-formula-editor/formula-editor/data-passing/FormulaTextLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function WebhookActionSummary({
  actionMetadata: {
    method,
    url
  }
}) {
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.webhook.summary",
    options: {
      request: method && url ? /*#__PURE__*/_jsxs(Text, {
        as: "code",
        wordBreak: "break-all",
        children: [method, " ", /*#__PURE__*/_jsx(FormulaTextLabel, {
          text: url
        })]
      }) : /*#__PURE__*/_jsx(MissingLabel, {
        type: "url"
      })
    }
  });
}
export default WebhookActionSummary;